import styled from 'styled-components';
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const CustomersLogosWrapper = styled.aside`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 50px 0;

  text-align: center;

  background-color: rgba(${getToken('color-background-secondary')});

  ${screen.lg} {
    padding: 100px 0;
  }
`;

export const LogosList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.spaced ? 'space-between' : 'space-evenly'};
  padding: 0;

  ${screen.md} {
    padding: 36px 0 0;
    flex-direction: row;
  }

  ${screen.lg} {
    padding: 50px 0 0;
  }
`;

export const Title = styled.h3`
  font-family: ${getToken('platform-font-title')};
  color: rgb(${getToken('color-text-primary')});
  font-weight: ${getToken('font-weight-bold')};
  font-size: 26px;
  line-height: 39px;
  text-align: center;
  margin: 0px;
  margin-bottom: 12px;
  padding: 0 12px;

  br:nth-child(1) {
    display: none;
  }

  br:nth-child(2) {
    display: none;
  }

  ${screen.md} {
    margin: 0px;
    padding: 0px;

    br:nth-child(2) {
      display: inline-block;
    }
  }

  ${screen.lg} {
    br:nth-child(2) {
      display: none;
    }
    br:nth-child(1) {
      display: inline-block;
    }
  }
`;

const Logo = styled.img`
  box-sizing: border-box;
  max-width: 100%;
  height: auto;
  margin: 24px auto;

  ${screen.md} {
    margin: 0;
  }
`;

export const LogoCabot = styled(Logo)`
  width: 92.82px;

  ${screen.lg} {
    width: 133.17px;
  }
  ${screen.xxlg} {
    width: 152.46px;
  }
`;

export const LogoHalli = styled(Logo)`
  width: 157.13px;

  ${screen.lg} {
    width: 225.44px;
  }
  ${screen.xxlg} {
    width: 258.1px;
  }
`;

export const LogoAlcoa = styled(Logo)`
  width: 134.41px;

  ${screen.lg} {
    width: 192.84px;
  }
  ${screen.xxlg} {
    width: 220.78px;
  }
`;

export const LogoAccent = styled(Logo)`
  width: 117.57px;

  ${screen.lg} {
    width: 168.68px;
  }
  ${screen.xxlg} {
    width: 193.12px;
  }
`;

export const LogoAmazon = styled(Logo)`
  width: 164px;

  ${screen.lg} {
    width: 256px;
  }
  ${screen.xxlg} {
    width: 293px;
  }
`;

export const LogoStoneLoads = styled(Logo)`
  width: 145px;
  height: 17px;

  ${screen.md} {
    margin: auto 0;
  }

  ${screen.lg} {
    height: 26px;
    width: 222px;
  }
  ${screen.xxlg} {
    height: 30px;
    width: 262px;
  }
`;

export const LogoHomeDepot = styled(Logo)`
  width: 85px;

  ${screen.lg} {
    width: 130px;
  }
  ${screen.xxlg} {
    width: 153px;
  }
`;

export const Content = styled.h3`
  font-family: ${getToken('platform-font-title')};
  color: rgb(${getToken('color-text-tertiary')});
  font-weight: ${getToken('font-weight-bold')};
  font-size: 26px;
  line-height: 39px;
  text-align: center;

  margin: 36px auto;

  br:nth-child(2) {
    display: none;
  }

  ${screen.md} {
    br:nth-child(1) {
      display: none;
    }
    br:nth-child(2) {
      display: inline-block;
    }
  }

  ${screen.lg} {
    margin-top: 50px;

    br:nth-child(2) {
      display: none;
    }
  }

  ${screen.xxlg} {
    margin-top: 36px;
  }
`;
